import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { FutureContractStatus } from "@/constants/entity-status";
import { capitalize } from "lodash";
import { FutureContractDetail } from "@/pages/grain-requests/future-contract/schema/future-contract.schema";
import { RequestStatusBadge } from "../../badge/RequestStatusBadge";

interface Props {
  futureContract?: FutureContractDetail | null;
}

export const FutureContractDetailMainDataCard = ({ futureContract }: Props) => {
  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={18}>
      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="16px"
            textTransform={"uppercase"}
            paddingX="24px"
            fontWeight={700}
          >
            Detalle
          </Text>
          <Grid templateColumns="repeat(2, 1fr)">
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Fecha de solicitud:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">
                {dayjs(futureContract?.fechaSolicitud).format("DD/MM/YYYY")}
              </Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Titular:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">{futureContract?.titular}</Text>
            </GridItem>
         
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Estado:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">
                <RequestStatusBadge
                  status={futureContract?.estado as FutureContractStatus}
                />
              </Text>
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>
      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="16px"
            textTransform={"uppercase"}
            paddingX="24px"
            fontWeight={700}
            visibility="hidden"
          >
            -
          </Text>
          <Grid templateColumns="repeat(2, 1fr)">
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Grano:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">
                {capitalize(futureContract?.grano.toLocaleLowerCase())}
              </Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Cosecha:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">{futureContract?.cosecha}</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Es canje:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">
                {futureContract?.esCanje ? "Sí" : "No"}
              </Text>
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>
    </Grid>
  );
};
